import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { IArkPesFund } from '../../data-models/arkpes-manage.data-model';
import { MaggieHttp } from '../MaggieHttp';

export interface PatchArkPesFundBody {
  includeInGl: boolean;
}

export async function fetchArkPesFunds() {
  const { data } = await MaggieHttp.maggie.get<IArkPesFund[]>('/arkpes/manage-funds');
  return data;
}

export async function patchArkPesFund(id: number, body: PatchArkPesFundBody) {
  const { data } = await MaggieHttp.maggie.patch<PatchArkPesFundBody, IArkPesFund>(
    `/arkpes/funds/${id}`,
    body
  );
  return data;
}

export function useArkPesFunds() {
  return useQuery({ queryKey: ['arkpes-manage', 'funds'], queryFn: fetchArkPesFunds });
}

export function useArkPesFundAction() {
  const queryClient = useQueryClient();

  const fund = useMutation({
    mutationFn: ({ id, body }: { id: number; body: PatchArkPesFundBody }) => patchArkPesFund(id, body),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['arkpes-manage'] });
    },
  });

  return { fund };
}
